import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Session from './auth/Session';
import AuthFunctions from './services/AuthService';
import AdminFunctions from './admin/AdminFunctions';

function Home (props) {
    const [role, setRole] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        async function isAuth() {
            var _token = Session.getToken();
            var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
            if (!isAuthenticated) {
                navigate('/login');
            }
        }
        isAuth();

        async function isAdmin() {
            const isAdmin = await AdminFunctions.isAdminAsync();
            if (isAdmin) {
                navigate('/admin/users');
                return;
            }
        }
        isAdmin();

        // set role if not admin
        setRole(Session.getRole());
    }, [])

    useEffect(() => {
        // route based on role
        if (role === "") return;

        switch (role) {
            case "Project Manager":
                navigate('/admin/job-listings');
                break;
            case "Crew":
                navigate('/daily-schedule');
                break;
            default:
                break;
        }
    }, [role])

        return (
            <>
                {/* <a href="/counter">Counter</a><br />
                <a href="/admin">Admin</a><br />
                <a href="/admin/roles">Roles</a><br />
                <a href="/admin/roles/create">CreateRole</a><br />
                <a href="/admin/roles/details">RoleDetails</a><br /> */}


                {/* <a href="/admin/users">Users</a><br />
                <a href="/admin/users/details">UserDetails</a><br />
                <a href="/admin/equipment">Equipment</a><br /> */}


                {/* <a href="/admin/clients">Clients</a><br />
                <a href="/admin/clients/create">CreateClient</a><br />
                <a href="/admin/clients/details">ClientDetails</a><br />
                <a href="/accessdenied">AccessDenied</a><br />
                <a href="/login">Log In</a><br />
                <a href="/logout">Log Out</a><br /> */}

            </>
        );
    
}
export default Home